import React from 'react';
import IndexedSubSectionWrapper from "hoc/IndexedSubSectionWrapper";
import {FBCommentQuestionToolTip} from 'components/break/tooltips/breaks-steps-section-tool-tips';

import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';
import {createButtonSectionFactoryWithAdditionalArgs} from "../../../../../hoc/CreateButtonSection";
import * as ResourceApi from "../../../../../api/resources";

import {
    SpotTheDifferenceHeadlineToolTip,
    SpotTheDifferenceIntroCopyToolTip,
    SpotTheDifferenceButtonTextToolTip,
    SpotTheDifferenceExampleImageToolTip,
    SpotTheDifferenceInstructionHeadlineToolTip,
    SpotTheDifferenceInstructionDescriptionToolTip,
    SpotTheDifferenceSceneSectionHeadlineToolTip,
    SpotTheDifferenceTimeLimitToolTip,
    SpotTheDifferenceOriginalImageToolTip,
    SpotTheDifferenceDifferencesImageToolTip,
    SpotTheDifferenceIdentifyDifferencesToolTip
} from 'components/break/tooltips/spot-the-difference-tool-tips';


export default {
    name: "spotTheDifferenceGame",
    subSection: true,
    resource: true,
    hideIfResourceIsNoU: true,

    fields: [
        {
          type: 'contenteditable',
          name: 'headline',
          required: true,
          // Headline is only allowed if there is more than one step
          showField: (proxy) => (proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1),
          linkedField: (proxy) => ["title"],
          props: {
              labelKey: 'editbreak.steps.spot_the_difference.headline',
              helpContent: <SpotTheDifferenceHeadlineToolTip/>,
              helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.spot_the_difference.headline'}/></IntlProvider>
          }
        },
        {
            type: 'contenteditable',
            name: 'introCopy',
            required: false,
            props: {
              labelKey: 'editbreak.steps.spot_the_difference.intro_copy',
              maxLength: 500,
              placeholderKey: 'editbreak.steps.spot_the_difference.intro_copy.placeholder',
              validationRules: [
                  {
                      type: 'MarkupTextLimit',
                      params: {
                          limit: 500
                      }
                  }
              ],
              helpContent: <SpotTheDifferenceIntroCopyToolTip/>,
              helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.spot_the_difference.intro_copy'}/></IntlProvider>
            }
        },
        {
            type: 'text',
            name: 'commentQuestion',
            showField: (proxy) => (proxy.currentBaseResource.showFBComments && proxy.currentBaseResource.sponsoredType !== 'sponsored' ),
            props: {
                labelKey: 'editbreak.steps.related_breaks.commentQuestion',
                helpContent: <FBCommentQuestionToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.breaks_steps.fbCommentQuestion'}/></IntlProvider>
            }
        },
        {
          type: 'text',
          name: 'buttonText',
          required: true,
          props: {
              labelKey: 'editbreak.steps.spot_the_difference.button_text',
              helpContent: <SpotTheDifferenceButtonTextToolTip/>,
              helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.spot_the_difference.button_text'}/></IntlProvider>
          }
        },
        {
          type: 'image',
          name: 'exampleImageId',
          idFor: 'exampleImage',
          props: {
            labelKey: 'editbreak.steps.spot_the_difference.example_image',
            imageType: 'spotDiffExampleImage',
            helpContent: <SpotTheDifferenceExampleImageToolTip/>,
            helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.spot_the_difference.example_image'}/></IntlProvider>
          }
        },
        {
          name: 'instructions',
          subSection: true,
          resource: true,
          collection: true,
          sectionWrapper: IndexedSubSectionWrapper,
          sortable: true,
          sortableName: "spotTheDifferenceGameInstructionsOrder",
          toggleSortLabelKey: 'editbreak.steps.spot_the_difference.instruction.reorder_toggle',
          deletable: true,
          props: {
            headerKey: 'editbreak.steps.spot_the_difference.instruction.header',
            getCustomSectionHeader: (instruction, sectionIndex) => {
              return  instruction.headline
                      && instruction.headline.trim() !== "" ? "Instruction " + (sectionIndex + 1) + ": " + instruction.headline : null;
            }
          },


          fields: [
            {
              type: 'contenteditable',
              name: 'headline',
              required: true,
              props: {
                labelKey: 'editbreak.steps.spot_the_difference.instruction.headline',
                helpContent: <SpotTheDifferenceInstructionHeadlineToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.spot_the_difference.instruction.headline'}/></IntlProvider>
              }
            },
            {
              type: 'contenteditable',
              name: 'desc',
              required: false,
              props: {
                labelKey: 'editbreak.steps.spot_the_difference.instruction.description',
                helpContent: <SpotTheDifferenceInstructionDescriptionToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.spot_the_difference.instruction.description'}/></IntlProvider>
              }
            }
          ],
            footerContent: createButtonSectionFactoryWithAdditionalArgs({
                instructionListName: "spotTheDifferenceInstruction"
            }, ResourceApi.Types.SpotTheDifferenceInstruction),
        }, // end instructions
        {
          name: 'levels',
          subSection: true,
          resource: true,
          collection: true,
          sectionWrapper: IndexedSubSectionWrapper,
          deletable: true,
          sortable: true,
          sortableName: "spotTheDifferenceGameLevelsOrder",
          toggleSortLabelKey: 'editbreak.steps.spot_the_difference.scene.reorder_toggle',
          props: {
            headerKey: 'editbreak.steps.spot_the_difference.scene.header',
            getCustomSectionHeader: (scene, sectionIndex) => {
              return  scene.headline
                      && scene.headline.trim() !== "" ? "Scene " + (sectionIndex + 1) + ": " + scene.headline : null;
            },
          },
          fields: [
            {
              type: 'contenteditable',
              name: 'headline',
              required: false,
              props: {
                labelKey: 'editbreak.steps.spot_the_difference.scene.headline',
                helpContent: <SpotTheDifferenceSceneSectionHeadlineToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.spot_the_difference.scene.headline'}/></IntlProvider>
              }
            },
            {
              type: 'number',
              name: 'timeLimit',
              required: true,
              props: {
                labelKey: 'editbreak.steps.spot_the_difference.scene.time_limit',
                min: 1,
                max: 180,
                helpContent: <SpotTheDifferenceTimeLimitToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.spot_the_difference.scene.time_limit'}/></IntlProvider>
              }
            },
            {
              type: 'image',
              name: 'image1Id',
              idFor: 'image1',
              required: true,
              props: {
                labelKey: 'editbreak.steps.spot_the_difference.scene.original_image',
                imageType: 'spotDif',
                helpContent: <SpotTheDifferenceOriginalImageToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.spot_the_difference.scene.original_image'}/></IntlProvider>
              }
            },
            {
              type: 'image',
              name: 'image2Id',
              idFor: 'image2',
              required: true,
              props: {
                labelKey: 'editbreak.steps.spot_the_difference.scene.differences_image',
                imageType: 'spotDif',
                helpContent: <SpotTheDifferenceDifferencesImageToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.spot_the_difference.scene.differences_image'}/></IntlProvider>
              }
            },
            {
              type: 'spotTheDiffPicker',
              props: {
                originalImage: (proxy) => (proxy.currentResource.image1),
                differencesImage: (proxy) => (proxy.currentResource.image2),
                helpContent: <SpotTheDifferenceIdentifyDifferencesToolTip/>
              }
            }
          ],
            footerContent: createButtonSectionFactoryWithAdditionalArgs({
                instructionListName: "spotTheDifferenceScene"
            }, ResourceApi.Types.SpotTheDifferenceLevel),
        } // end levels
    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/spot-the-difference.js